
import React, { useEffect, useState } from "react";
import utils from "../../../Utils/index";
import Widgets from "../../../Widgets/index";
// import ProposeTimeLogDialog from "../childComponent/lastAppointmentDialog/lastAppointmentDialog";
// import LastAppointmentDialog from "../childComponent/proposeTimeLogDialog/proposeTimeLogDialog";
import "./InfoComponent.css";
import { t } from "../../../Utils/translate";
import ReactCountryFlag from "react-country-flag"

function InfoComponent({
  icon,
  title,
  subtitle,
  data,
  status,
  showAdditionalDataBtn,
  showMapBtn,
  fullData,
  showAdditionalDataBtnId,
  extraData,
  redirectToLastAppointment,
  requestedTimingDetails,
  flagCode
}) {
  const [dataList, setDataList] = useState([]);
  const [openProposeNewTimeDialog, setOpenProposeNewTimeDialog] = useState(false);

  const [openLastAppointmentDialog, setOpenLastAppointmentDialog] = useState(false);

  const [appointmentStatusLabel, setAppointmentStatusLabel] = useState(null);
  const [appointmentStatusLabelType, setAppointmentStatusLabelType] = useState("");

  const [extraDataValue, setExtraDataValue] = useState(null);

  useEffect(() => {
    renderData();
    setExtraDataValue(extraData)
  }, [icon, title, subtitle, data, status, showAdditionalDataBtn, showMapBtn, fullData, showAdditionalDataBtnId, extraData, flagCode]);

  function renderData() {
    let arr = [];
    for (let key in data) {
      if (data.hasOwnProperty(key)) {
        var val = data[key];
        arr.push(val);
      }
    }
    setDataList(arr);
    setUpAppointmentState()
  }

  function setUpAppointmentState() {
    if (fullData) {
      let appointmentStatus;
      switch (fullData.appointmentState) {
        case "Pending":
          appointmentStatus = utils.strings.miscellaneous.pending;
          break;
        case "Pending":
          appointmentStatus = utils.strings.miscellaneous.pending;
          break;
        case "Cancelled":
          appointmentStatus = utils.strings.miscellaneous.cancelled;
          break;
        default:
          appointmentStatus = fullData.appointmentState;
      }
      setAppointmentStatusLabelType(fullData.appointmentState)
      setAppointmentStatusLabel(appointmentStatus)
    }
  }
  function handleDialog() {
    switch (showAdditionalDataBtnId) {
      case utils.constants.appointmentDetailDialog.proposedTimeLog:
        setOpenProposeNewTimeDialog(true);
        break;
      case utils.constants.appointmentDetailDialog.lastAppointment:
        setOpenLastAppointmentDialog(true);
        break;
    }
  }
  function handleMapDialog() {
    if (
      fullData.userAddress &&
      fullData.userAddress.geoLocation[1] &&
      fullData.userAddress.geoLocation[0]
    ) {
      let latitude = fullData.userAddress.geoLocation[1];
      let longitude = fullData.userAddress.geoLocation[0];
      window.open("https://maps.google.com?q=" + latitude + "," + longitude);
    }
  }

  return (
    <>
      {openProposeNewTimeDialog ? (
        // <ProposeTimeLogDialog
        //   visible={(val) => {
        //     setOpenProposeNewTimeDialog(val);
        //   }}
        //   data={extraDataValue}
        //   requestedTimingDetails={requestedTimingDetails}
        // />
        console.log("TIME DIALOG")
      ) : null}

      {openLastAppointmentDialog ? (
        // <LastAppointmentDialog
        //   visible={(val) => {
        //     setOpenLastAppointmentDialog(val);
        //   }}
        //   data={extraDataValue}
        //   redirect={() => {
        //     if (redirectToLastAppointment) {
        //       redirectToLastAppointment()
        //     }
        //   }}
        // />
        console.log("LAST TIME APPOINTMENT DIALOG")
      ) : null}


      <div className="info-container">
        <div>
          {title != null && title != "" ? (
            <div className="d-flex appointment-details-titles">
              {icon}
              <span>{title}</span>
            </div>
          ) : null}
          <span className="name-flag-view">
            <h4
              data-toggle="tooltip"
              title={subtitle}
              className="appointment-details-subtitles">{subtitle}</h4>
            {flagCode &&
              <span className="cross-country-flag">
                <ReactCountryFlag countryCode={flagCode} svg />
              </span>
            }
          </span>
          {dataList.map((item, i) => {
            return (
              <div key={i}>
                <span className="appointment-details-content">{item}</span>
                {i < dataList.length ? <br /> : ""}
              </div>
            );
          })}
          {status != null && appointmentStatusLabel ? (
            <Widgets.AppointmentStatus
              label={appointmentStatusLabel}
              labelType={appointmentStatusLabelType}
            />
          ) : null}
        </div>
        {showAdditionalDataBtn ? (
          <div>
            <button
              className="small-button"
              onClick={() => {
                handleDialog();
              }}
            >
              {t("details")}
            </button>
          </div>
        ) : null}
        {showMapBtn ? (
          <div>
            <button
              className="small-button"
              onClick={() => {
                handleMapDialog();
              }}
            >
              {t("openMap")}
            </button>
          </div>
        ) : null}
      </div >
    </>
  );
}

export default InfoComponent;
